import React from "react";
import TablePagination from "../sharedPages/CommonComponents/NewPagination/NewPagination";
import { Table } from "react-bootstrap";
import ProfileImg from "../../assets/images/Profile.svg";

import "./tradesTable.css";

const VerifyMyTradesTable = ({
  title = "",
  columns = [],
  data = [],
  allData = [],
  currentPage = 1,
  totalPages = 1,
  onPageChange = () => {},
  noDataMessage = "No data found",
  stylingComp = {},
  showCheckbox = false,
  selectedRows = [],
  onRowSelect = () => {},
  onSelectAll = () => {},
  showSelectAllCheckbox = false,
}) => {
  // Calculate if all rows are selected (check against all data, not just current page)
  const dataToCheck = allData.length > 0 ? allData : data;
  const allRowsSelected =
    dataToCheck.length > 0 &&
    dataToCheck.every((row) => {
      const rowIdentifier = row.id || dataToCheck.indexOf(row);
      return selectedRows.includes(rowIdentifier);
    });

  // Handle select all checkbox
  const handleSelectAll = () => {
    onSelectAll(!allRowsSelected);
  };

  // Find Asset column (symbol key) and separate it from other columns when checkbox is shown
  const assetColumnIndex = showCheckbox ? columns.findIndex(col => col.key === "symbol") : -1;
  const assetColumn = assetColumnIndex !== -1 ? columns[assetColumnIndex] : null;
  const otherColumns = showCheckbox && assetColumn 
    ? columns.filter((col, index) => index !== assetColumnIndex)
    : columns;
  
  // Calculate width for remaining columns (distribute evenly)
  const remainingColumnsCount = otherColumns.length;
  const remainingWidthPercent = remainingColumnsCount > 0 ? `${100 / remainingColumnsCount}%` : "auto";

  return (
    <div className="verifyTradePaymentablerWrapper">
      <div className={`GenericTableCard`} style={stylingComp}>
      {/* <div className="row">
        <div className="col-lg-6 col-md-6 col-12"></div>
        <div className="col-lg-6 col-md-6 col-12"></div>
      </div> */}
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="TableBox">
            <Table style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  {showSelectAllCheckbox && assetColumn ? (
                    <th style={{ width: "178px", minWidth: "178px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div className="checkbox-container">
                          <input
                            type="checkbox"
                            checked={allRowsSelected}
                            onChange={handleSelectAll}
                            className="table-checkbox"
                          />
                        </div>
                        <p style={{ margin: 0 }}>{assetColumn.label}</p>
                      </div>
                    </th>
                  ) : showSelectAllCheckbox ? (
                    <th style={{ width: "50px", minWidth: "50px" }}>
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={allRowsSelected}
                          onChange={handleSelectAll}
                          className="table-checkbox"
                        />
                      </div>
                    </th>
                  ) : null}
                  {otherColumns.map((col, index) => (
                    <th key={index} style={{ width: col.width || remainingWidthPercent }}>
                      <p>{col.label}</p>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={
                        showCheckbox && assetColumn 
                          ? otherColumns.length + 1 
                          : showCheckbox 
                          ? columns.length + 1 
                          : columns.length
                      }
                      className="text-center py-4"
                    >
                      {noDataMessage}
                    </td>
                  </tr>
                ) : (
                  data.map((row, rowIndex) => {
                    const rowIdentifier = row.id || rowIndex;
                    const isSelected = selectedRows.includes(rowIdentifier);

                    return (
                      <tr
                        key={rowIdentifier}
                        className={isSelected ? "selected-row" : ""}
                      >
                        {showCheckbox && assetColumn ? (
                          <td style={{ width: "250px", minWidth: "250px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <div className="checkbox-container">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => onRowSelect(row, rowIndex)}
                                  className="table-checkbox"
                                />
                              </div>
                              <div className="profileItem" style={{ flex: 1, margin: 0 }}>
                                {assetColumn.type === "profile" && (
                                  <img src={ProfileImg} alt="profile" />
                                )}
                                <p style={{ margin: 0 }}>{row[assetColumn.key] || "-"}</p>
                              </div>
                            </div>
                          </td>
                        ) : showCheckbox ? (
                          <td style={{ width: "50px", minWidth: "50px" }}>
                            <div className="checkbox-container">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => onRowSelect(row, rowIndex)}
                                className="table-checkbox"
                              />
                            </div>
                          </td>
                        ) : null}
                        {otherColumns.map((col, colIndex) => {
                          let cellContent;
                          let customClass = "";
                          if (typeof col.render === "function") {
                            cellContent = col.render(row);
                          } else {
                            const cellData = row[col.key];
                            const cellSmallData = row[col?.keySmall];
                            let displayValue = cellData;
                            if (
                              typeof cellData === "object" &&
                              cellData !== null
                            ) {
                              displayValue = cellData.value || "-";
                              customClass = cellData.className || "";
                            }
                            cellContent = (
                              <>
                                {displayValue || "-"}{" "}
                                <span>{cellSmallData}</span>
                              </>
                            );
                          }
                          const handleClick = () => {
                            if (typeof col.onClick === "function") {
                              col.onClick(row);
                            }
                          };
                          return (
                            <td
                              key={colIndex}
                              onClick={col.onClick ? handleClick : undefined}
                              style={{
                                cursor: col.onClick ? "pointer" : "default",
                                width: col.width || remainingWidthPercent,
                              }}
                            >
                              <div className="profileItem">
                                {col.type === "profile" && (
                                  <img src={ProfileImg} alt="profile" />
                                )}
                                <p className={customClass}>{cellContent}</p>
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {totalPages > 0 && (
        <div className="mt-2">
          <TablePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
      </div>
    </div>
  );
};

export default VerifyMyTradesTable;
